import { FormattedMessage } from "react-intl";
import { Outlet } from "react-router-dom";
import { Box, Heading } from "@chakra-ui/react";
import SiteFooter from "./SiteFooter.js";

function OrderLayout() {
  return (
    <Box backgroundColor="gray.100" minHeight="100vh">
      <Box
        backgroundColor="white"
        borderColor="primary"
        borderLeftWidth={6}
        borderRightWidth={6}
        minHeight="100vh"
        width={{ base: "auto", sm: "80vw" }}
        mx="auto"
        px={{ base: "3", sm: "5" }}
        display="flex"
        flexDirection="column"
      >
        <Heading as="h1" variant="site" textAlign="center" size="2xl">
          <FormattedMessage id="its-picture-day" />
        </Heading>
        <Box flex="1 0 auto">
          <Outlet />
        </Box>
        <SiteFooter />
      </Box>
    </Box>
  );
}

export default OrderLayout;
